import { render, staticRenderFns } from "./mixRatio.vue?vue&type=template&id=4d4c56fa&scoped=true"
import script from "./mixRatio.vue?vue&type=script&lang=js"
export * from "./mixRatio.vue?vue&type=script&lang=js"
import style0 from "./mixRatio.vue?vue&type=style&index=0&id=4d4c56fa&prod&lang=scss&scoped=true"
import style1 from "./mixRatio.vue?vue&type=style&index=1&id=4d4c56fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c56fa",
  null
  
)

export default component.exports